export const locationSurchargeType = {
  origin: "origin",
  destination: "destination",
  both: "both",
};
